import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import AppPointPay from './app-pointpay';
import { LoadingScreen } from './components/loading-screen';

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <Suspense fallback={<LoadingScreen />}>
        <AppPointPay />
      </Suspense>
    </BrowserRouter>
  </HelmetProvider>
);
